import { PaletteMode } from "@mui/material";
import { Components, createTheme, Palette, Theme } from "@mui/material";
import { TypographyOptions } from "@mui/material/styles/createTypography";

export const colours = {
  white: "#ffffff",
  coreContent: "#101F3B",
  coreHoverStateLight: "#F5F5F5",
  coreHoverStateDark: "#595959",

  coreSurfaceDark: "#343434",

  coreActiveStateLight: "#EBF3FB",
  coreActiveStateDark: "#263039",

  mutinexMagenta: "#EC0089",

  "Alerts/Waiting Outline": "#565EFA",
};

const typography = (palette: Palette): TypographyOptions => ({
  fontFamily: ["Montserrat", "Roboto", "sans-serif"].join(","),
  h2: {
    fontFamily: "Montserrat",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "29.26px",
  },
  h3: {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "21.94px",
  },
  body1: {
    fontSize: "14px",
    lineHeight: "17px",
    fontWeight: 400,
  },
  allVariants: {
    color: palette.mode === "dark" ? palette.common.white : colours.coreContent,
  },
});

const commonComponentOverrides: Components<Omit<Theme, "components">> = {
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
  },
};

const lightTheme = createTheme({
  palette: {
    mode: "light",
    background: {
      paper: "#ffffff",
    },
    primary: {
      main: colours.coreContent,
    },
    secondary: {
      main: colours.coreHoverStateLight,
    },
    mutinexMagenta: {
      main: colours.mutinexMagenta,
      contrastText: "#fff",
    },
    active: {
      main: "#EBF3FB",
      contrastText: "#000",
    },
    toggleButton: {
      background: "#0e2244",
      textColor: "#FFF",
      hoverBackground: "#273D63",
      hoverTextColor: "#FFF",
    },
  },
  typography,
  components: commonComponentOverrides,
});

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      paper: "#242423",
    },
    primary: {
      main: colours.white,
    },
    secondary: {
      main: colours.coreSurfaceDark,
    },
    mutinexMagenta: {
      main: colours.mutinexMagenta,
      contrastText: "#fff",
    },
    active: {
      main: "#263039",
      contrastText: "#fff",
    },
    toggleButton: {
      background: "#FFF",
      textColor: "#000",
      hoverBackground: "#D3D3D3",
      hoverTextColor: "#000",
    },
  },
  typography,
  components: commonComponentOverrides,
});

export const getTheme = (themeType: PaletteMode) => (themeType === "dark" ? darkTheme : lightTheme);
